// extracted by mini-css-extract-plugin
module.exports = {"loader":"_3pGvP","load7":"_3FicL"};